import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media, BREAK_POINT } from '@Utils/MediaQuery';

const Layout = forwardRef(({ children }, ref) => {
  return (
    <Container ref={ref}>
      <Inner>{children}</Inner>
    </Container>
  );
});

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

Layout.displayName = 'Layout';

const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;

  height: 100vh;
  overflow-y: scroll;

  -webkit-overflow-scrolling: touch;

  padding: 0px 20px;

  ${media.lessThan(BREAK_POINT.XS)`
    padding: 16px;
  `}
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 752px;
  height: 100%;
`;

export default Layout;
